import { api } from 'app/config/apiConfig';

import { Box } from '../model/types';

export const activateBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    activateBox: builder.mutation<Box, string>({
      query: (boxId) => ({
        url: `/boxes/${boxId}/activate`,
        method: 'PUT',
      }),
      invalidatesTags: ['Boxes', 'Available boxes', 'Warehouses for booking'],
    }),
  }),
});

export const { useActivateBoxMutation } = activateBoxApi;
